function CircumstanceItem({ circumstance, handleClickCircumstance }) {
  return (
    <div
      className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full border-b border-slate-200 last:border-b-0"
      onClick={handleClickCircumstance}>
      {circumstance.images.map((image) => (
        <img className="h-32 block rounded-md" src={image.file_500} alt={image.title} />
      ))}
      <div className="flex flex-col justify-around h-full w-full">
        <div className="text-xl font-bold  ">{circumstance.title}</div>
        <div className="text-base font-medium  ">{circumstance.description}</div>
      </div>
    </div>
  );
}

export default CircumstanceItem;
